import { RegistrationStatusTagCombinedProps } from './types';

const usePresenter = (props: RegistrationStatusTagCombinedProps): RegistrationStatusTagCombinedProps => {
  return props;
};

export default usePresenter;
